// borrowerapplication\src\app\plaid-link\plaid-link.component.ts

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plaid-link',
  templateUrl: './plaid-link.component.html',
  styleUrls: ['./plaid-link.component.scss']
})
export class PlaidLinkComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    // Optionally trigger Plaid right on load, or do it via a button.
  }

  openPlaidLink() {
    // No logic here
  }
}
